import PropertyShow from './PropertyShow';

export default PropertyShow;
